import src from "IMAGE";
export default { src, width: 800, height: 128, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJElEQVR42mNYM69jm7u9sb+yrLClkoyQOZQ2U5ERNvJRUQkHAJE7ByZgEoXoAAAAAElFTkSuQmCC"};
